import { useCallback, useEffect, useState } from 'react';
import { fetchAuditLogs, type AuditLog } from '@/services/audit';

export function useAudit(limit = 200) {
  const [data, setData] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchAuditLogs(limit)
      .then((res) => {
        if (cancelled) return;
        setData(res.data);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Error al cargar la auditoría');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [limit]);

  useEffect(() => load(), [load]);

  return { data, loading, error, refetch: load };
}